import { useEffect } from "react";
import {
  generatePath,
  Navigate,
  useNavigate,
  useParams,
} from "react-router-dom";

import { LoadingState } from "~/common/components";
import { PATIENT_CONSULTATION_STATUS } from "~/common/constants/consultation";
import { CONSULTATION_STATUSES } from "~/common/utils";
import { intakeSectionTitle } from "~/common/utils/consultations/intake";
import { StartConsultationSection } from "~/patients/components/consultations";
import { useGetCurrentPatient, useGetIntake } from "~/patients/hooks";
import { useStartIntake } from "~/patients/hooks/queries/consultations/intake/useStartIntake";
import { ROUTES } from "~/patients/router";

export const StartIntake = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data: user } = useGetCurrentPatient();

  const { id: consultationId, status: userStatus } = { ...user?.consultation };

  const providerImage =
    user?.organization_patients[0].primary_provider?.profile_picture_path;

  const screeningCompleted =
    userStatus === PATIENT_CONSULTATION_STATUS.intake_not_started ||
    userStatus === PATIENT_CONSULTATION_STATUS.intake_started;

  const userCanAccessIntake =
    !!id &&
    !!user?.organization_patients[0].email_verified_at &&
    screeningCompleted;

  const { data: intakeData, isLoading } = useGetIntake(
    id,
    consultationId,
    userCanAccessIntake,
  );

  const { startIntakeMutation, isPending } = useStartIntake();

  const { status } = {
    ...intakeData,
  };

  const redirectToScreeningIfStarted = () => {
    if (status === CONSULTATION_STATUSES.in_progress && id) {
      navigate(
        generatePath(ROUTES.intake, {
          id,
        }),
      );
    }
    if (status === CONSULTATION_STATUSES.completed) {
      navigate(ROUTES.screeningAlreadyCompleted);
    }
  };

  useEffect(redirectToScreeningIfStarted, [redirectToScreeningIfStarted]);

  if (!userCanAccessIntake) return <Navigate to={ROUTES.notFound} />;

  if (isLoading || !intakeData)
    return <LoadingState className="h-screen-calculated" />;

  const { order, duration, code } = {
    ...intakeData,
  };

  return (
    <StartConsultationSection
      section={order}
      duration={duration}
      title={intakeSectionTitle[code]}
      handleContinue={() => startIntakeMutation({ id, consultationId })}
      handleGoBack={() => navigate(ROUTES.leadPatientHome)}
      pendingContinue={isPending}
      providerImageSrc={providerImage}
    />
  );
};
